import React from "react";
import dashboardclasses from "../../dashboard.module.css";
function VendorInfo({ user }) {
    return (
        <div className={dashboardclasses["users-details-wrapper"]}>
            <div className={dashboardclasses["user-details"]}>
                <h4>Name</h4>
                <h5>:</h5>
                <p>{user.name}</p>
            </div>

            <div className={dashboardclasses["user-details"]}>
                <h4>Mobile Number</h4>
                <h5>:</h5>
                <p>
                    {user.mobile}{" "}
                    {user?.altMobile?.length > 0 &&
                        user?.altMobile !== "NA" &&
                        user?.altMobile !== "na" &&
                        `, ${user?.altMobile}`}
                </p>
            </div>

            <div className={dashboardclasses["user-details"]}>
                <h4>Gender</h4>
                <h5>:</h5>
                <p>{user.gender}</p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>Address</h4>
                <h5>:</h5>
                <p>
                    {user.address}
                    <br /> {user.pinCode}
                </p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>City</h4>
                <h5>:</h5>
                <p>{user.city}</p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>Status</h4>
                <h5>:</h5>
                <p>{user.status}</p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>Service Location</h4>
                <h5>:</h5>
                <p>{user.ServiceLocationAddress}</p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>Referral Code</h4>
                <h5>:</h5>
                <p>{user.refcode}</p>
            </div>
            <div className={dashboardclasses["user-details"]}>
                <h4>wallet Balance </h4>
                <h5>:</h5>
                <p>{user.walletBalance}</p>
            </div>

            <div className={dashboardclasses["user-details"]}>
                <h4>Created </h4>
                <h5>:</h5>
                <p>
                    {String(new Date(user.created).getDate()).padStart(2, "0")}-
                    {String(new Date(user.created).getMonth() + 1).padStart(
                        2,
                        "0"
                    )}
                    -{new Date(user.created).getFullYear()}{" "}
                    {/* {new Date(
                user.createdAt
            ).getHours()}
            :
            {String(
                new Date(
                    user.createdAt
                ).getMinutes()
            ).padStart(2, "0")} */}
                </p>
            </div>
        </div>
    );
}

export default VendorInfo;
